<div class="flex items-center">
  <p-tieredMenu #userActions [model]="items" [popup]="true" [appendTo]="'body'"></p-tieredMenu>

  <div class="clickable-avatar cursor-pointer inline-flex items-center" (click)="onAvatarClick($event, userActions)">
    <div class="user-info" *ngIf="!isMobile">
      <div class="user-name">{{ userName }}</div>
      <div class="user-org" *ngIf="currentOrganizationName">{{ currentOrganizationName }}</div>
    </div>
    <p-avatar
      image="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAMAAACnDzTfAAAArlBMVEX7yC77yC3+yC3+xy/+xy39yC39yCz9yCv8ySr+xjH/yyz+zjf/zDr3zCf/0C7tvz6bfi1WRh1FNRU/LxN/Zyqihi4AAAB2YCT/0DaNdCsAAAOqiSzCnzRGNhS9mS7aszzjvEPqwDefj2trZ2QdEQCUdyr2zENhTBtsWCDKysn////Y2dbwxkoQBAhuZ1txcG0XEApdX2J6e3mMcSPp6eiUdhuQkI3ktDgyJhJKOxl6O9euAAABQ0lEQVR4AbWQVYLDMAwFZZCsOCm3WmaGMt//YmuV8XMnYD+PGcAYAwY2r8Z1sucBdxYPSGiJyJK1hESESEpKBCGBDj0pfoXlLHNBHaFHJm/9FmZyXl1wWYj5HkUOzOq4VK5Ua/U9Gs3cASHZoiVHXJQRnPGXVyLX6Vmh9Wu5iQye4+3S3N0/PD7eNkSNyJNlyCBfxouH5xd5fXv/EOXzEhFcfBClfvv1/f2TRv++ptR+ss4Bx5vFUjed70RX5OpGpPcQMzZp3JUo1b66Qao9yGcl6pWAK9++vVXfWkMZfX+PRN1Trio5JhtjLJfHIpNJT9207M3SGXZIkIX7zeme2DMtXPqIOYRilpr1nG+Rgip1K+LDtSi1ImCKe87Ep+asN78pAtGhcw7zoihiSUcdOKbgGEuZ98duy/86tOhR8Vps0PQHIRAktypFIpIAAAAASUVORK5CYII="
      shape="circle"
      size="normal"
      [style]="{ width: '2.2rem', height: '2.2rem' }"
      styleClass="mr-2 mt-1"
    />
  </div>
</div>

<p-drawer
  [(visible)]="drawerVisible"
  position="bottom"
  [modal]="true"
  [styleClass]="'user-actions-drawer'"
  [style]="{ height: 'auto', 'max-height': '70vh', 'border-radius': '1rem 1rem 0 0' }"
>
  <ng-template pTemplate="header">
    <div class="drawer-header">
      <p-avatar
        image="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAMAAACnDzTfAAAArlBMVEX7yC77yC3+yC3+xy/+xy39yC39yCz9yCv8ySr+xjH/yyz+zjf/zDr3zCf/0C7tvz6bfi1WRh1FNRU/LxN/Zyqihi4AAAB2YCT/0DaNdCsAAAOqiSzCnzRGNhS9mS7aszzjvEPqwDefj2trZ2QdEQCUdyr2zENhTBtsWCDKysn////Y2dbwxkoQBAhuZ1txcG0XEApdX2J6e3mMcSPp6eiUdhuQkI3ktDgyJhJKOxl6O9euAAABQ0lEQVR4AbWQVYLDMAwFZZCsOCm3WmaGMt//YmuV8XMnYD+PGcAYAwY2r8Z1sucBdxYPSGiJyJK1hESESEpKBCGBDj0pfoXlLHNBHaFHJm/9FmZyXl1wWYj5HkUOzOq4VK5Ua/U9Gs3cASHZoiVHXJQRnPGXVyLX6Vmh9Wu5iQye4+3S3N0/PD7eNkSNyJNlyCBfxouH5xd5fXv/EOXzEhFcfBClfvv1/f2TRv++ptR+ss4Bx5vFUjed70RX5OpGpPcQMzZp3JUo1b66Qao9yGcl6pWAK9++vVXfWkMZfX+PRN1Trio5JhtjLJfHIpNJT9207M3SGXZIkIX7zeme2DMtXPqIOYRilpr1nG+Rgip1K+LDtSi1ImCKe87Ep+asN78pAtGhcw7zoihiSUcdOKbgGEuZ98duy/86tOhR8Vps0PQHIRAktypFIpIAAAAASUVORK5CYII="
        shape="circle"
        size="large"
      />
      <div class="drawer-user-info">
        <div class="drawer-user-name">{{ userName }}</div>
        <div class="drawer-user-email" *ngIf="currentOrganizationName">{{ currentOrganizationName }}</div>
      </div>
    </div>
  </ng-template>

  <div class="drawer-menu">
    <ng-container *ngFor="let item of mobileItems; let i = index">
      <div
        class="drawer-menu-item"
        (click)="onMobileItemClick(item)"
        [class.logout]="item.label === 'Cerrar Sesión'"
        [class.disabled]="item.disabled"
      >
        <i *ngIf="item.icon" [class]="item.icon"></i>
        <span>{{ item.label }}</span>
      </div>
      <div
        class="drawer-divider"
        *ngIf="item.separator || (i < mobileItems.length - 1 && item.label !== 'Cerrar Sesión' && mobileItems[i + 1]?.label === 'Cerrar Sesión')"
      ></div>
    </ng-container>
  </div>
</p-drawer>
